import { render, staticRenderFns } from "./UrlShortenerWhattsApp.vue?vue&type=template&id=230dca39&scoped=true&"
import script from "./UrlShortenerWhattsApp.vue?vue&type=script&lang=js&"
export * from "./UrlShortenerWhattsApp.vue?vue&type=script&lang=js&"
import style0 from "./UrlShortenerWhattsApp.vue?vue&type=style&index=0&id=230dca39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230dca39",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAutocomplete,VCol,VDivider,VFadeTransition,VForm,VIcon,VRow,VSwitch,VTextField,VTextarea})
